import * as React from 'react';
import {flow, map} from 'lodash';
import {connect} from 'react-redux';
import {Table} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {IStore} from '../../../../redux/IStore';
import {IContent} from '../../../../services/content/models';
import Question from './components/Question';

interface IFAQProps {
  contents: IContent[];
  minimal?: boolean;
}

class FAQ extends React.Component<IFAQProps> {
  private getFaqs = () => {
    const { contents } = this.props;
    return contents.filter((content: IContent) => {
      return content.name === 'Frequently Asked Questions';
    }).shift();
  }

  public render() {
    const { minimal } = this.props;
    const faq = this.getFaqs();
    if (!faq) {
      return null;
    }

    const questions = map(faq.sections.questions, (questions, key) => {
      return (
        <div className="faqs admiral-table mb-20" key={key}>
          <Table>
            <thead>
            <tr>
              <th data-sm-show="show">{key}</th>
            </tr>
            </thead>
            <tbody>
            {questions.map((question, index) => {
              if (minimal) {
                if (index > 3) {
                  return;
                }
                return (
                  <tr key={index}>
                    <td>{question.question}</td>
                  </tr>
                );
              }
              return (
                <tr key={index}>
                  <td>
                    <Question question={question} />
                  </td>
                </tr>
              );
            })}
            {minimal && (
              <tr>
                <td>
                  <Link to={`/account/faqs`}>
                    Click here to view more >>>
                  </Link>
                </td>
              </tr>
            )}
            </tbody>
          </Table>
        </div>
      );
    });

    if (minimal) {
      return (
        <>
          <h2><strong>FAQs</strong></h2>
          {questions}
        </>
      );
    }

    return (
      <div className="page-container">
        <h2><strong>FAQs</strong></h2>
        {questions}
      </div>
    );
  }
}

export default flow([
  connect(
    (state: IStore) => {
      return {
        contents: state?.content?.content || [],
      };
    },
  ),
])(FAQ);
